import React from "react";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Dialog from "material-ui/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import FlatButton from "material-ui/FlatButton";
import Input from "@material-ui/core/Input";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormHelperText from "@material-ui/core/FormHelperText";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";

const styles = theme => ({
  root: {
    display: "flex",
    flexWrap: "wrap"
  },
  formControl: {
    margin: theme.spacing.unit,
    minWidth: 120
  },
  selectEmpty: {
    marginTop: theme.spacing.unit * 2
  }
});

export default class OnboardingDialog extends React.Component {
  state = {
    open: this.props.showDialog
  };

  handleConfirm = () => {
    this.props.startOnboarding();
    this.setState({ open: false });
  };

  handleDeny = () => {
    this.setState({ open: false });
  };

  handleStopOnboarding = () => {
    this.props.stopOnboarding();
    this.setState({ open: false})
  }

  render() {
    return (
      <div style={{ textAlign: "center" }}>
        <Dialog
          open={this.state.open}
          onClose={this.handleClose}
          aria-labelledby="delete-dialog-title"
          contentStyle={{ width: "500px" }}
        >
          <DialogContent>
            <br />
            <DialogContentText>
              <p style={{ fontWeight: 300, fontSize: 30 }}>
                Hey There!<span role="img" aria-labelledby="emoji">
                  {" "}
                  👋
                </span>
              </p>
            </DialogContentText>
            <DialogContentText>
              Thanks for signing up for our services! Mozak is a virtual assistant
              company here to help you save time on tasks so you can focus on
              what's important. Do you want to learn how to use our product?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              variant="outlined"
              onClick={this.handleDeny}
              color="secondary"
            >
              I'll pass this time
            </Button>
            <Button
              variant="outlined"
              onClick={this.handleConfirm}
              color="primary"
            >
              Yes! Let's start
            </Button>
            <Button
            variant="outlined"
            onClick={this.handleStopOnboarding}
            color="primary"
          >
            Never Show again
          </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/project/start_onboarding_dialog.js